import React, { useEffect, useState } from "react";
import { Donut } from "react-dial-knob";
import toast, { Toaster } from "react-hot-toast";
import { ShimmerThumbnail } from "react-shimmer-effects";
import LineChart from "../ChartsImpl/FeedbackDashboardChart/LineChart";
import TotalFeedback from "../../assets/images/dashboard/total.png";
import TodayFeedback from "../../assets/images/dashboard/today.png";
import PositiveFeedback from "../../assets/images/dashboard/positive.png";
import NegativeFeedback from "../../assets/images/dashboard/negative.png";
import MobileNo from "../../assets/images/dashboard/mobile.png";
import Comments from "../../assets/images/dashboard/comments.png";
import DatePicker from "react-datepicker";
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import moment from "moment/moment";
import { MDBDataTable } from "mdbreact";
import { Accordion, Badge, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {connectMQTT,
        subscribeTopic,
        unsubscribeTopic,
        disconnectMQTT} from "../../services/mqttService";

const FeedbackDashboard = () => {
  const [messages, setMessages] = useState([]);

  // app's light/dark mode toggle (Theme Settings > Light Version)
  const lightVersion = useSelector((state) => state.settings.lightVersion);
  const chartAxisColor = lightVersion ? "#8a909a" : "#c9ced4";
  const chartLineColor = lightVersion ? "#e1e8ed" : "#3a3f45";

  const location = useLocation();
  const navigate = useNavigate();

  const { sDate, eDate } = location.state || {};
  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("user_token");
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const feedbackDashboardUpdate = `feedback/dashboard/branch`;

  const [allFeedbackList, setAllFeedbackList] = useState([]);
  // const [selectedKiosks, setSelectedKiosks] = useState(null);
  const [kiosks, setKiosks] = useState([]);

  const [allDataLoaded, setAllDataLoaded] = useState(true);
  const [feedbackStats, setFeedbackStats] = useState(null);
  const [queueCountersData, setQueueCountersData] = useState(null);
  const [unselectedQueueCounters, setUnselectedQueueCounters] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [cardList, setCardList] = useState([
    {
      icon: TotalFeedback,
      count: 0,
      label: "Total Feedbacks",
    },
    {
      icon: TodayFeedback,
      count: 0,
      label: "Today Feedbacks",
    },
    {
      icon: MobileNo,
      count: 0,
      label: "Mobile Numbers",
    },
  ]);
  // const [branchId, setBranchId] = useState(null);
  const [branchSqeuenceData, setBranchSqeuenceData] = useState({});

  const [selectedBranchId, setSelectedBranchId] = useState(userDetails?.bid);
  const [selectedBranchName, setSelectedBranchName] = useState(null);
  const [selectedBranchLevel, setSelectedBranchLevel] = useState(null);
  // const [selectedBranchQueueType, setSelectedBranchQueueType] = useState(null);

  const [country, setCountry] = useState({});
  const [selectedCountry, setselectedCountry] = useState(null);
  const [province, setprovince] = useState({});
  const [provinces, setProvinces] = useState([]);
  const [selectedProvince, setselectedProvince] = useState(null);
  const [district, setdistrict] = useState({});
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setselectedDistrict] = useState(null);
  const [userBranch, setuserBranch] = useState({});
  const [branches, setBranches] = useState([]);
  const [selectedUserBranch, setSelectedUserBranch] = useState(null);

  useEffect(() => {
    if (sDate || eDate) {
      setStartDate(sDate);
      setEndDate(eDate);
    }
  }, [sDate, eDate]);

  useEffect(() => {
    getChartData();
    getCounters();
    // getFeedbackList();
  }, [selectedBranchId]);

  useEffect(() => {
    getDashboardStats();
  }, [startDate, endDate, selectedBranchId]);

  useEffect(() => {
    if (messages.length > 0) {
      console.log("messages: ", messages);
      getDashboardStats();
      getChartData();
    }
  }, [messages]);

  useEffect(() => {
    getDashboardStats();
    getChartData();
  }, [kiosks]);


  const onMessageArrived = (message) => {
    console.log('Message received:', message.payloadString);
    setMessages((prev) => [...prev, message.payloadString]);
  };

  const onConnect = () => {
    console.log('Connected to MQTT broker');
    subscribeTopic(feedbackDashboardUpdate + `/${selectedBranchId}`);
  };

  const onConnectionLost = (responseObject) => {
    if (responseObject.errorCode !== 0) {
      console.error('Connection lost:', responseObject.errorMessage);
    }
  };

  useEffect(() => {
    if (selectedBranchLevel === 4) {
      // Connect on mount
      connectMQTT(
          // 'broker.hivemq.com', // change to your broker
          // 8884, // or 8883 for SSL, or 8000 for WebSocket
          // `client_${Math.random().toString(16).substr(2, 8)}`,
          onMessageArrived,
          onConnect,
          onConnectionLost
      );

      // Cleanup on unmount
      return () => {
        unsubscribeTopic(feedbackDashboardUpdate + `/${selectedBranchId}`);
        disconnectMQTT();
      };
    }
  }, [selectedBranchId, selectedBranchLevel]);

  // useEffect(() => {
  //   if (queueCountersData !== null && queueCountersData.length > 0) {
  //     for (let i = 0; i < queueCountersData.length; i++) {
  //       for (let j = 0; j < selectedRow.roleFeatures.length; j++) {
  //
  //         if (allPermissions[i].id === selectedRow.roleFeatures[j].id) {
  //           allPermissions[i].selected = true;
  //         }
  //       }
  //     }
  //   }
  // }, [queueCountersData]);

  const getDashboardStats = () => {

    const selectedKiosks = kiosks !== null && kiosks.length > 0 ? kiosks : null;
    console.log("kiosks: ", selectedKiosks);
    axios({
      method: "POST",
      url: `${baseUrl}/feedback/dashboard/table`,
      headers: {
        Authorization: token,
      },
      data: {
        branchId: selectedBranchId || userDetails.bid,
        size: 100,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
        kiosks: selectedKiosks,
        page: 0,
        sort: {
          name: "",
          direction: "",
        },
        searchText: "",
      },
    })
      .then((res) => {
        let data = res.data.data;
        setFeedbackStats(data);

        if (data) {
          let emojiList = data.questionFeedbackSummaries[0];

          if (emojiList) {
            let emojiArray = Object.keys(emojiList)
              .filter((key) => /^[\p{Emoji}]+$/u.test(key))
              .map((key) => ({ label: key, field: key }));

            setAllFeedbackList(emojiArray);
          }

          setCardList((prevCardList) =>
            prevCardList.map((card, index) => {
              if (index === 0) return { ...card, count: data?.totalFeedbacks };
              if (index === 1) return { ...card, count: data?.todayFeedbacks };
              if (index === 2) return { ...card, count: data?.mobileNumbers };
              return card;
            })
          );

          setAllDataLoaded(true);
        }
      })
      .catch((error) => {
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  const getSelectedKiosk = (selectedIdx) => {
    if (queueCountersData !== null
        && queueCountersData.length > 0
        && selectedIdx !== null) {
      const array = [];
      if (selectedIdx !== 'All') {
        array.push(queueCountersData[selectedIdx].kioskId);
        setKiosks(array);
      } else {
        setKiosks(null);
      }

    }


  }

  const getChartData = () => {
    axios({
      method: "POST",
      url: `${baseUrl}/feedback/dashboard/chart`,
      headers: {
        Authorization: token,
      },
      data: {
        branchId: selectedBranchId || userDetails.bid,
        kiosks: null,
      }
    })
      .then((res) => {
        let data = res.data.data;
        setChartData(data);
      })
      .catch((error) => {
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  const getCounters = () => {

    const branchIds = [selectedBranchId || userDetails.bid];

    axios({
      method: "POST",
      url: `${baseUrl}/feedback/get/queue-branches`,
      headers: {
        Authorization: token,
      },
      data: {
        branchIds: branchIds,
      }
    })
        .then((res) => {
          let data = res.data.data;
          setQueueCountersData(data);
        })
        .catch((error) => {
          console.log(error);

          if (error.response !== undefined) {
            toast.remove();
            toast.error(error.response.data.message, {
              position: "bottom-center",
            });
          } else {
            toast.remove();
            toast.error("Something went wrong", {
              position: "bottom-center",
            });
          }
        });
  };

  const getFeedbackList = () => {
    axios({
      method: "GET",
      url: `${baseUrl}/feedback/get-all/branch/${userDetails.bid}`,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        let data = res.data.data;

        const feedbackColumns = data.map((feedback) => ({
          label: feedback.image,
          field: feedback.image,
        }));

        setAllFeedbackList(feedbackColumns);
      })
      .catch((error) => {
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  const options = {
    chart: {
      height: 300,
      type: "area",
      stacked: false,
      toolbar: {
        show: false,
      },
      background: "transparent",
    },
    theme: {
      mode: lightVersion ? "light" : "dark",
    },

    colors: ["#6435c9", "#f66d9b", "#CED4DC"],
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: "gradient",
      gradient: {
        opacityFrom: 0.6,
        opacityTo: 0.8,
      },
    },

    legend: {
      position: "top",
      horizontalAlign: "right",
      show: false,
    },
    xaxis: {
      categories: chartData?.days.slice(29, 60),
      type: "string",
      labels: {
        style: {
          colors: chartAxisColor,
        },
      },
      axisBorder: {
        color: chartLineColor,
      },
      axisTicks: {
        color: chartLineColor,
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: chartAxisColor,
        },
      },
    },
    grid: {
      borderColor: chartLineColor,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    stroke: {
      show: true,
      curve: "smooth",
      width: 1,
    },
    tooltip: {
      theme: lightVersion ? "light" : "dark",
    },
  };

  const series = [
    {
      name: "Feedbacks",
      data: chartData?.counts.slice(29, 60),
    },
  ];

  const updatedQuestions = feedbackStats?.questionFeedbackSummaries.map((q) => {
    allFeedbackList.forEach((emoji) => {
      if (!(emoji.label in q)) {
        q[emoji.label] = "-"; // Add missing emojis with 0 feedback
      }
    });

    return {
      ...q,
      question: (
        <>
          <p>
            {q.question}{" "}
            {q.deleted && <span className="badge badge-danger">Deleted</span>}
          </p>
        </>
      ),
      clickEvent: () =>
        navigate(`/question-wise-dashboard`, {
          state: {
            qid: q.questionId,
            question: q.question,
            bid: selectedBranchId,
            sDate: startDate,
            eDate: endDate,
          },
        }),
    };
  });

  let tableData = {
    columns: [
      {
        label: "Questions",
        field: "question",
        width: 200,
      },

      {
        label: "Feedbacks",
        field: "feedbacks",
      },
      ...allFeedbackList,
    ],
    rows: updatedQuestions,
  };

  useEffect(() => {
    if (baseUrl.length > 0 && token.length > 0) {
      getBranchSequence();
    }
  }, [baseUrl, token, selectedBranchId]);

  useEffect(() => {
    if (
      selectedProvince !== undefined &&
      selectedProvince !== null &&
      userDetails["branchLevel"] !== 4
    ) {
      getDistricts(selectedProvince, 0);
    }
  }, [selectedProvince]);

  useEffect(() => {
    if (selectedDistrict !== undefined && selectedDistrict !== null) {
      getBranches(selectedDistrict);
    }
  }, [selectedDistrict]);

  const getBranchSequence = () => {
    // userDetails['userType']
    axios({
      method: "GET",
      url: `${baseUrl}/branch/get-sequence/branch/${selectedBranchId}`,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        console.log("getBranchSequence success");
        let data = res.data.data;
        setBranchSqeuenceData(data);

        if (data.countryId !== undefined) {
          setselectedCountry(data.countryId);
          getCountry(data.countryId);
          getProvinces(data.countryId, data.provinceId);
        }

        if (data.provinceId !== undefined) {
          setselectedProvince(data.provinceId);
          getDistricts(data.provinceId, data.districtId);
        }

        if (data.districtId !== undefined) {
          setselectedDistrict(data.districtId);
          getBranches(data.districtId);
        }

        if (data.branchId !== undefined) {
          setSelectedUserBranch(data.branchId);
        }
      })
      .catch((error) => {
        console.log("getBranchSequence error");
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  const getCountry = (country) => {
    axios({
      method: "GET",
      url: `${baseUrl}/branch/get-branch/${country}`,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        console.log("getCountry success");
        let data = res.data.data;
        setCountry(data);
      })
      .catch((error) => {
        console.log("getCountry error");
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  const getProvinces = (country, province) => {
    let url = ``;

    if (userDetails["branchLevel"] === 1) {
      url = `${baseUrl}/branch/get-all/parent-branch/${country}`;
    } else if (
      userDetails["branchLevel"] === 3 ||
      userDetails["branchLevel"] === 4
    ) {
      url = `${baseUrl}/branch/get-branch/${province}`;
    } else {
      url = `${baseUrl}/branch/get-branch/${userDetails["bid"]}`;
    }

    axios({
      method: "GET",
      url: url,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        console.log("getProvinces success");
        let data = res.data.data;
        console.log("province data: ", data);
        if (userDetails["branchLevel"] === 1) {
          setProvinces(data);
        } else {
          setprovince(data);
        }
      })
      .catch((error) => {
        console.log("getProvinces error");
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  const getDistricts = (province, district) => {
    let url = ``;

    if (userDetails["branchLevel"] === 1 || userDetails["branchLevel"] === 2) {
      url = `${baseUrl}/branch/get-all/parent-branch/${province}`;
    } else if (userDetails["branchLevel"] === 4) {
      url = `${baseUrl}/branch/get-branch/${district}`;
    } else {
      url = `${baseUrl}/branch/get-branch/${userDetails["bid"]}`;
    }

    axios({
      method: "GET",
      url: url,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        console.log("getDistricts success");
        let data = res.data.data;

        if (
          userDetails["branchLevel"] === 1 ||
          userDetails["branchLevel"] === 2
        ) {
          setDistricts(data);
        } else {
          setdistrict(data);
        }
      })
      .catch((error) => {
        console.log("getDistricts error");
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  const getBranches = (district) => {
    let url = ``;

    if (userDetails["branchLevel"] === 4) {
      url = `${baseUrl}/branch/get-branch/${userDetails["bid"]}`;
    } else {
      url = `${baseUrl}/branch/get-all/parent-branch/${district}`;
    }

    axios({
      method: "GET",
      url: url,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        console.log("getBranches success");
        let data = res.data.data;

        if (userDetails["branchLevel"] === 4) {
          setuserBranch(data);
        } else {
          if (data !== null) {
            setBranches(data);
          }
        }
      })
      .catch((error) => {
        console.log("getBranches error");
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  return (
    <>
      <div>
        <Toaster />
      </div>

      <>
        <div className="block-header block-header-padding">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1>Feedback Dashboard</h1>
            </div>
          </div>
        </div>

        <div className="container-fluid branch-dashboard mt-4">
          {userDetails["branchLevel"] !== 4 ? (
            <div className="row clearfix">
              <div className="col-md-12 col-sm-8 p-l-5 p-r-5 mb-4">
                <div className="card">
                  <div className="body">
                    <div className="row">
                      <div className="col-md-12 col-sm-12 p-l-5 p-r-5">
                        <Accordion className="accordion" id="accordion">
                          <div>
                            <div className="card-header " id="headingOne">
                              <h5 className="mb-0">
                                <Accordion.Toggle
                                  as={Button}
                                  variant="link"
                                  eventKey="0"
                                  className={
                                    selectedBranchLevel === 4
                                      ? "acc-color-branch"
                                      : selectedBranchLevel === 3
                                      ? "acc-color-district"
                                      : selectedBranchLevel === 2
                                      ? "acc-color-province"
                                      : "acc-color-country"
                                  }
                                >
                                  {branchSqeuenceData.name}
                                  <div className="float-right">
                                    <i className="fa fa-chevron-circle-down"></i>
                                  </div>
                                </Accordion.Toggle>
                              </h5>
                            </div>
                            <Accordion.Collapse
                              eventKey="0"
                              className="collapse"
                            >
                              <div className="body">
                                <div className="row clearfix">
                                  <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="card">
                                      <div className="taskboard b-cyan progress_task">
                                        <h6 className="font300 mb-3">
                                          Country
                                        </h6>
                                        <div
                                          className="dd"
                                          data-plugin="nestable"
                                        >
                                          {userDetails["branchLevel"] === 1 ? (
                                            <div
                                              className={`dd-handle align-items-center ${
                                                selectedCountry === country.id
                                                  ? "active"
                                                  : ""
                                              }`}
                                              // key={country.id}
                                              onClick={() => {
                                                setselectedCountry(country.id);
                                                setselectedProvince(null);
                                                setselectedDistrict(null);
                                                setSelectedUserBranch(null);
                                                setDistricts([]);
                                                setBranches([]);
                                              }}
                                            >
                                              <div className="d-flex justify-content-between">
                                                <div>{country.name}</div>
                                                <div
                                                  className={
                                                    selectedBranchId ===
                                                    country.id
                                                      ? "btn btn-prymary select-btn external-link-active"
                                                      : "btn btn-prymary select-btn"
                                                  }
                                                  onClick={() => {
                                                    setSelectedBranchId(
                                                      country.id
                                                    );
                                                    setSelectedBranchName(
                                                      country.name
                                                    );
                                                    setSelectedBranchLevel(
                                                      country.level
                                                    );
                                                  }}
                                                >
                                                  <i className="fa fa-external-link float-left"></i>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            <div
                                              className="dd-handle align-items-center"
                                              style={{ cursor: "default" }}
                                            >
                                              <div className="d-flex justify-content-between">
                                                <div>{country.name}</div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="card">
                                      <div className="taskboard b-cyan progress_task">
                                        <h6 className="font300 mb-3">
                                          Province
                                        </h6>
                                        <div
                                          className="dd"
                                          data-plugin="nestable"
                                        >
                                          {provinces !== null ? (
                                            <>
                                              {userDetails["branchLevel"] ===
                                              1 ? (
                                                <>
                                                  {provinces.map((data, i) => (
                                                    <div
                                                      className={`dd-handle align-items-center ${
                                                        selectedProvince ===
                                                        data.id
                                                          ? "active"
                                                          : ""
                                                      }`}
                                                      key={i}
                                                      onClick={() => {
                                                        setselectedProvince(
                                                          data.id
                                                        );
                                                        setselectedDistrict(
                                                          null
                                                        );
                                                        setSelectedUserBranch(
                                                          null
                                                        );
                                                        setBranches([]);
                                                      }}
                                                    >
                                                      <div className="d-flex justify-content-between">
                                                        <div>{data.name}</div>
                                                        <div
                                                          className={
                                                            selectedBranchId ===
                                                            data.id
                                                              ? "btn btn-prymary select-btn external-link-active"
                                                              : "btn btn-prymary select-btn"
                                                          }
                                                          onClick={() => {
                                                            setSelectedBranchId(
                                                              data.id
                                                            );
                                                            setSelectedBranchName(
                                                              data.name
                                                            );
                                                            setSelectedBranchLevel(
                                                              data.level
                                                            );
                                                          }}
                                                        >
                                                          <i className="fa fa-external-link float-left"></i>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ))}
                                                </>
                                              ) : userDetails["branchLevel"] ===
                                                2 ? (
                                                <div
                                                  className={`dd-handle align-items-center ${
                                                    selectedProvince ===
                                                    province.id
                                                      ? "active"
                                                      : ""
                                                  }`}
                                                  onClick={() => {
                                                    setselectedProvince(
                                                      province.id
                                                    );
                                                    setselectedDistrict(null);
                                                    setSelectedUserBranch(null);
                                                    setBranches([]);
                                                  }}
                                                >
                                                  <div className="d-flex justify-content-between">
                                                    <div>{province.name}</div>
                                                    <div
                                                      className={
                                                        selectedBranchId ===
                                                        province.id
                                                          ? "btn btn-prymary select-btn external-link-active"
                                                          : "btn btn-prymary select-btn"
                                                      }
                                                      onClick={() => {
                                                        setSelectedBranchId(
                                                          province.id
                                                        );
                                                        setSelectedBranchName(
                                                          province.name
                                                        );
                                                        setSelectedBranchLevel(
                                                          province.level
                                                        );
                                                      }}
                                                    >
                                                      <i className="fa fa-external-link float-left"></i>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div
                                                  className="dd-handle align-items-center"
                                                  style={{
                                                    cursor: "default",
                                                  }}
                                                >
                                                  <div className="d-flex justify-content-between">
                                                    <div>{province.name}</div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          ) : (
                                            <div
                                              className={`dd-handle align-items-center`}
                                            >
                                              <div className="d-flex justify-content-between">
                                                <div> No provices yet... </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="card">
                                      <div className="taskboard b-cyan progress_task">
                                        <h6 className="font300 mb-3">
                                          District
                                        </h6>
                                        <div
                                          className="dd"
                                          data-plugin="nestable"
                                        >
                                          {userDetails["branchLevel"] === 1 ||
                                          userDetails["branchLevel"] === 2 ? (
                                            <>
                                              {districts !== null ? (
                                                <>
                                                  {districts.length > 0 ? (
                                                    <>
                                                      {districts.map(
                                                        (data, i) => (
                                                          <div
                                                            className={`dd-handle align-items-center ${
                                                              selectedDistrict ===
                                                              data.id
                                                                ? "active"
                                                                : ""
                                                            }`}
                                                            key={i}
                                                            onClick={() => {
                                                              setselectedDistrict(
                                                                data.id
                                                              );
                                                              setSelectedUserBranch(
                                                                null
                                                              );
                                                            }}
                                                          >
                                                            <div className="d-flex justify-content-between">
                                                              <div>
                                                                {data.name}
                                                              </div>
                                                              <div
                                                                className={
                                                                  selectedBranchId ===
                                                                  data.id
                                                                    ? "btn btn-prymary select-btn external-link-active"
                                                                    : "btn btn-prymary select-btn"
                                                                }
                                                                onClick={() => {
                                                                  setSelectedBranchId(
                                                                    data.id
                                                                  );
                                                                  setSelectedBranchName(
                                                                    data.name
                                                                  );
                                                                  setSelectedBranchLevel(
                                                                    data.level
                                                                  );
                                                                }}
                                                              >
                                                                <i className="fa fa-external-link float-left"></i>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      )}
                                                    </>
                                                  ) : (
                                                    <div
                                                      className={`dd-handle align-items-center`}
                                                    >
                                                      <div className="d-flex justify-content-between">
                                                        <div>
                                                          {" "}
                                                          Select Provice{" "}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}
                                                </>
                                              ) : (
                                                <div
                                                  className={`dd-handle align-items-center`}
                                                >
                                                  <div className="d-flex justify-content-between">
                                                    <div>
                                                      {" "}
                                                      No districts yet...{" "}
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          ) : userDetails["branchLevel"] ===
                                            3 ? (
                                            <div
                                              className={`dd-handle align-items-center ${
                                                selectedDistrict === district.id
                                                  ? "active"
                                                  : ""
                                              }`}
                                              onClick={() => {
                                                setselectedDistrict(
                                                  district.id
                                                );
                                                setSelectedUserBranch(null);
                                              }}
                                            >
                                              <div className="d-flex justify-content-between">
                                                <div>{district.name}</div>
                                                <div
                                                  className={
                                                    selectedBranchId ===
                                                    district.id
                                                      ? "btn btn-prymary select-btn external-link-active"
                                                      : "btn btn-prymary select-btn"
                                                  }
                                                  onClick={() => {
                                                    setSelectedBranchId(
                                                      district.id
                                                    );
                                                    setSelectedBranchName(
                                                      district.name
                                                    );
                                                    setSelectedBranchLevel(
                                                      district.level
                                                    );
                                                  }}
                                                >
                                                  <i className="fa fa-external-link float-left"></i>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            <div
                                              className="dd-handle align-items-center"
                                              style={{ cursor: "default" }}
                                            >
                                              <div className="d-flex justify-content-between">
                                                <div>{district.name}</div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="card">
                                      <div className="taskboard b-cyan progress_task">
                                        <h6 className="font300 mb-3">Branch</h6>
                                        <div
                                          className="dd"
                                          data-plugin="nestable"
                                        >
                                          {userDetails["branchLevel"] === 1 ||
                                          userDetails["branchLevel"] === 2 ||
                                          userDetails["branchLevel"] === 3 ? (
                                            <>
                                              {branches !== null ? (
                                                <>
                                                  {branches.length > 0 ? (
                                                    <>
                                                      {branches.map(
                                                        (data, i) => (
                                                          <div
                                                            className={`dd-handle align-items-center ${
                                                              selectedUserBranch ===
                                                              data.id
                                                                ? "active"
                                                                : ""
                                                            }`}
                                                            key={i}
                                                            onClick={() => {
                                                              setSelectedUserBranch(
                                                                data.id
                                                              );
                                                            }}
                                                          >
                                                            <div className="d-flex justify-content-between">
                                                              <div>
                                                                {data.name}
                                                              </div>
                                                              <div
                                                                className={
                                                                  selectedBranchId ===
                                                                  data.id
                                                                    ? "btn btn-prymary select-btn external-link-active"
                                                                    : "btn btn-prymary select-btn"
                                                                }
                                                                onClick={() => {
                                                                  setSelectedBranchId(
                                                                    data.id
                                                                  );
                                                                  setSelectedBranchName(
                                                                    data.name
                                                                  );
                                                                  setSelectedBranchLevel(
                                                                    data.level
                                                                  );
                                                                  // setSelectedBranchQueueType(
                                                                  //   data.branchQueueType
                                                                  // );
                                                                }}
                                                              >
                                                                <i className="fa fa-external-link float-left"></i>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      )}
                                                    </>
                                                  ) : (
                                                    <div
                                                      className={`dd-handle align-items-center`}
                                                    >
                                                      <div className="d-flex justify-content-between">
                                                        <div>
                                                          {" "}
                                                          Select District{" "}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}
                                                </>
                                              ) : (
                                                <div
                                                  className={`dd-handle align-items-center`}
                                                >
                                                  <div className="d-flex justify-content-between">
                                                    <div>
                                                      {" "}
                                                      No branches yet...{" "}
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          ) : userDetails["branchLevel"] ===
                                            4 ? (
                                            <div
                                              className={`dd-handle align-items-center ${
                                                selectedUserBranch ===
                                                userBranch.id
                                                  ? "active"
                                                  : ""
                                              }`}
                                              onClick={() => {
                                                setSelectedUserBranch(
                                                  userBranch.id
                                                );
                                                setSelectedBranchId(
                                                  userBranch.id
                                                );
                                                setSelectedBranchName(
                                                  userBranch.name
                                                );
                                                setSelectedBranchLevel(
                                                  userBranch.level
                                                );
                                                // setSelectedBranchQueueType(
                                                //   userBranch.branchQueueType
                                                // );
                                              }}
                                            >
                                              <div className="d-flex justify-content-between">
                                                <div>{userBranch.name}</div>
                                                <div
                                                  className={
                                                    selectedBranchId ===
                                                    userBranch.id
                                                      ? "btn btn-prymary select-btn external-link-active"
                                                      : "btn btn-prymary select-btn"
                                                  }
                                                >
                                                  <i className="fa fa-external-link float-left"></i>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            <div
                                              className="dd-handle align-items-center"
                                              style={{ cursor: "default" }}
                                            >
                                              <div className="d-flex justify-content-between">
                                                <div>{userBranch.name}</div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Collapse>
                          </div>
                        </Accordion>
                      </div>
                    </div>
                  </div>
                </div>
                {
                  queueCountersData !== null && queueCountersData.length > 0 ? (
                      <select
                          className="custom-select modal-select-field mr-2 select-branch-dropdown"
                          id="inputGroupSelect01"
                          // value={branchDropDValue}
                          onChange={(e) => {
                            getSelectedKiosk(e.target.value);
                            // handleSelectBranch(allBranchesList[e.target.value]);
                          }}
                      >
                        <option defaultValue hidden>
                          Select Counter
                        </option>
                        <option>
                          All
                        </option>
                        {queueCountersData.map((item, index) => (
                            <option value={index} key={index}>
                              {item.queueBranchName} - {item.queueCounterName}
                            </option>
                        ))}
                      </select>
                  ) : (
                      null
                  )
                }
                {/*<div className="body">*/}
                  {/*<div className="row clearfix">*/}
                    {/*<div className="col-lg-11">*/}

                      {/*{queueCountersData !== null && queueCountersData.length > 0 ?*/}

                          {/*queueCountersData.map((data, i) => (*/}
                                  {/*<span className={`badge ${data.selected ? "badge-success" : "badge-default"}`}*/}
                                        {/*style={{cursor:'pointer'}}*/}
                                        {/*onClick={() => handleSelect(i)}*/}
                                  {/*>{data.queueCounterName} - {data.queueBranchName}</span>*/}
                              {/*)*/}
                          {/*) : (*/}
                              {/*<p className="mb-0">No roles assigned</p>*/}
                          {/*)*/}
                      {/*}*/}


                    {/*</div>*/}

                    {/*/!*{userRolesEditAccess ? (*!/*/}
                        {/*/!*<div className="col-lg-1">*!/*/}
                          {/*/!*<button type="button" className="btn btn-sm btn-default" title=""*!/*/}
                                  {/*/!*data-toggle="tooltip"*!/*/}
                                  {/*/!*data-placement="top" onClick={() => {*!/*/}
                            {/*/!*setShowUserRolesModal(true);*!/*/}
                          {/*/!*}}*!/*/}
                          {/*/!*><i className="fa fa-pencil"> </i></button>*!/*/}
                        {/*/!*</div>*!/*/}
                    {/*/!*) : null}*!/*/}

                  {/*</div>*/}
                {/*</div>*/}
              </div>
            </div>
          ) : null}

          {allDataLoaded === false ? (
            <>
              <div className="row clearfix">
                {/* 1st row | 1st col*/}
                <div className="col-lg-3 col-md-12 col-sm-12 p-l-5 p-r-10">
                  <ShimmerThumbnail height={"100%"}>
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body">
                        <div>Issued Tickets</div>
                        <div className="py-4 m-0 text-center h1 text-light-green"></div>
                        <div className="d-flex">
                          <small className="text-muted">Hourly Update</small>
                          <div className="ml-auto"></div>
                        </div>
                      </div>
                    </div>
                  </ShimmerThumbnail>

                  <ShimmerThumbnail height={"100%"}>
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body">
                        <div>Ticket Served</div>
                        <div className="py-4 m-0 text-center h1 text-light-green">
                          258
                        </div>
                        <div className="d-flex">
                          <small className="text-muted">Hourly Update</small>
                          <div className="ml-auto">
                            <i className="fa fa-caret-up text-light-green mr-1"></i>
                            4%
                          </div>
                        </div>
                      </div>
                    </div>
                  </ShimmerThumbnail>

                  <ShimmerThumbnail height={"100%"}>
                    <div
                      className="card"
                      style={{ cursor: "pointer" }}
                      // onClick={() => toggleOperatorStatusDetails(!isOperatorStatusDetails, 'this is operator status')}
                    >
                      <div className="body">
                        <div>Operator Status</div>
                        <div className="py-4 m-0 text-center h4">
                          <div className="display-inline-block mr-4 text-light-green">
                            <i className="fa fa-eye mr-1"></i> 05
                          </div>
                          <div className="display-inline-block text-diseble">
                            <i className="fa fa-eye-slash mr-1"></i> 19
                          </div>
                        </div>
                        <div className="d-flex">
                          <small className="text-muted">Hourly Update</small>
                          <div className="ml-auto">
                            <i className="fa fa-caret-up text-light-green mr-1"></i>
                            4%
                          </div>
                        </div>
                      </div>
                    </div>
                  </ShimmerThumbnail>
                </div>

                {/* 1st row | 2st col*/}
                <div className="col-lg-4 col-md-6 col-sm-12 p-l-15 p-r-10">
                  <ShimmerThumbnail height={"100%"}>
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body top_counter">
                        <div className="content vertically-align-center-flex">
                          <span>Serving Ticket</span>
                          <h5 className="number mb-0 text-light-green">62</h5>
                        </div>
                      </div>
                    </div>
                  </ShimmerThumbnail>

                  <ShimmerThumbnail height={"100%"}>
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body top_counter">
                        <div className="content vertically-align-center-flex">
                          <span>Wait Time Exception</span>
                          <h5 className="number mb-0 text-maroon">32</h5>
                        </div>
                      </div>
                    </div>
                  </ShimmerThumbnail>

                  <ShimmerThumbnail height={"100%"}>
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body top_counter">
                        <div className="content vertically-align-center-flex">
                          <span>Service Time Exception</span>
                          <h5 className="number mb-0 text-maroon">17</h5>
                        </div>
                      </div>
                    </div>
                  </ShimmerThumbnail>
                </div>

                {/* 1st row | 3st col*/}
                <div className="col-lg-4 col-md-6 col-sm-12 p-l-15 p-r-10">
                  <ShimmerThumbnail height={"100%"}>
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body text-center">
                        <div className=" text-center d-flex justify-content-center mb-3">
                          <Donut
                            style={{ fontSize: "20px" }}
                            className="knob"
                            diameter={80}
                            min={0}
                            max={100}
                            step={1}
                            value={50}
                            theme={{
                              donutThickness: 3,
                              donutColor: "#5EB902",
                              centerColor: "#282B2F",
                              bgrColor: "#383b40",
                            }}
                          />
                        </div>
                        <h4 className="mb-3">Waiting Tickets</h4>
                        <div className="d-flex">
                          <small>Hourly Update</small>
                          <div className="ml-auto">
                            <i className="fa fa-caret-up mr-1"></i>3%
                          </div>
                        </div>
                      </div>
                      <div className="card-chart-bg">
                        <LineChart
                          data={[0, 0, 0, 0, 0, 0, 0]}
                          color="#5EB902"
                        />
                      </div>
                    </div>
                  </ShimmerThumbnail>

                  <ShimmerThumbnail height={"100%"}>
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body">
                        <div className="card-with-right-donut">
                          <div>
                            <h6 className="mb-3">Local Waiting</h6>
                            <div className="d-flex">
                              <small className="mr-3">Hourly Update</small>
                              <div className="ml-auto">
                                <i className="fa fa-caret-up mr-1"></i>3%
                              </div>
                            </div>
                          </div>
                          <Donut
                            style={{ fontSize: "20px" }}
                            className="knob"
                            diameter={60}
                            min={0}
                            max={100}
                            step={1}
                            value={50}
                            theme={{
                              donutThickness: 3,
                              donutColor: "#F1C40E",
                              centerColor: "#282B2F",
                              bgrColor: "#383b40",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </ShimmerThumbnail>

                  <ShimmerThumbnail height={"100%"}>
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body">
                        <div className="card-with-right-donut">
                          <div>
                            <h6 className="m-0">Counter status</h6>
                          </div>
                          <Donut
                            style={{ fontSize: "20px" }}
                            className="knob"
                            diameter={60}
                            min={0}
                            max={100}
                            step={1}
                            value={50}
                            theme={{
                              donutThickness: 3,
                              donutColor: "#F1C40E",
                              centerColor: "#282B2F",
                              bgrColor: "#383b40",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </ShimmerThumbnail>
                </div>

                {/* 1st row | 3st col*/}
                <div className="col-lg-3 col-md-6 col-sm-12 p-l-15 p-r-15">
                  <ShimmerThumbnail height={"100%"}>
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body text-center">
                        <div className=" text-center d-flex justify-content-center mb-3">
                          <Donut
                            style={{ fontSize: "20px" }}
                            className="knob"
                            diameter={80}
                            min={0}
                            max={100}
                            step={1}
                            value={50}
                            theme={{
                              donutThickness: 3,
                              donutColor: "#5EB902",
                              centerColor: "#282B2F",
                              bgrColor: "#383b40",
                            }}
                          />
                        </div>
                        <h4 className="mb-3">Waiting Tickets</h4>
                        <div className="d-flex">
                          <small>Hourly Update</small>
                          <div className="ml-auto">
                            <i className="fa fa-caret-up mr-1"></i>3%
                          </div>
                        </div>
                      </div>
                      <div className="card-chart-bg">
                        <LineChart
                          data={[0, 0, 0, 0, 0, 0, 0]}
                          color="#5EB902"
                        />
                      </div>
                    </div>
                  </ShimmerThumbnail>

                  <ShimmerThumbnail height={"100%"}>
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body">
                        <div className="card-with-right-donut">
                          <div>
                            <h6 className="mb-3">Local Waiting</h6>
                            <div className="d-flex">
                              <small className="mr-3">Hourly Update</small>
                              <div className="ml-auto">
                                <i className="fa fa-caret-up mr-1"></i>3%
                              </div>
                            </div>
                          </div>
                          <Donut
                            style={{ fontSize: "20px" }}
                            className="knob"
                            diameter={60}
                            min={0}
                            max={100}
                            step={1}
                            value={50}
                            theme={{
                              donutThickness: 3,
                              donutColor: "#F1C40E",
                              centerColor: "#282B2F",
                              bgrColor: "#383b40",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </ShimmerThumbnail>

                  <ShimmerThumbnail height={"100%"}>
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body">
                        <div className="card-with-right-donut">
                          <div>
                            <h6 className="m-0">Counter status</h6>
                          </div>
                          <Donut
                            style={{ fontSize: "20px" }}
                            className="knob"
                            diameter={60}
                            min={0}
                            max={100}
                            step={1}
                            value={50}
                            theme={{
                              donutThickness: 3,
                              donutColor: "#F1C40E",
                              centerColor: "#282B2F",
                              bgrColor: "#383b40",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </ShimmerThumbnail>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row clearfix">
                {cardList.map((i, index) => (
                  <div className="col-lg-4 col-md-12 col-sm-12 p-l-5 p-r-10">
                    <div className="card" style={{ cursor: "pointer" }}>
                      <div className="body py-4 d-flex justify-content-around">
                        <img src={i.icon} className="my-1" />

                        <div className="d-flex flex-column align-items-center">
                          <h4>{i.count}</h4>
                          <p className="text-muted my-1">{i.label}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row clearfix">
                <div className="col-lg-5 col-md-12 col-sm-12 p-l-5 p-r-5">
                  <div className="card" style={{ cursor: "pointer" }}>
                    <div className="body ">
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="my-0 mb-4">Recent Feedbacks</h6>
                        <Button
                          variant="primary"
                          size="sm"
                          className="mb-4"
                          onClick={() => navigate("/all-feedbacks")}
                        >
                          All
                        </Button>
                      </div>
                      <div className="my-0 py-0 custom-scroll">
                        <div
                          className=""
                          style={{ height: "315px", overflowY: "scroll" }}
                        >
                          {feedbackStats?.recentFeedbacks &&
                            feedbackStats.recentFeedbacks.map((i, index) => (
                              <div
                                key={i.id}
                                className="py-3 px-4 mb-2 d-flex justify-content-between align-items-center gap-4"
                                style={{
                                  background: `rgba(157, 157, 157, 0.1)`,
                                }}
                              >
                                <div
                                  className="mt-1 mb-0 mr-2"
                                  style={{ flex: "1 1 auto", minWidth: 0 }}
                                >
                                  <p className="mb-0">{i?.question}</p>
                                  <small className="text-muted">
                                    {i?.givenDateTime}
                                  </small>
                                </div>
                                <div
                                  className="text-center flex-shrink-0"
                                  style={{ width: "60px" }}
                                >
                                  <h5 className="mb-0">{i?.image}</h5>
                                  <small className="text-muted">
                                    {i?.givenFeedback}
                                  </small>
                                </div>

                                {/* <img
                                    src={i?.image}
                                    style={{
                                      width: "20px",
                                      objectFit: "contain",
                                    }}
                                  />
                               */}
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 col-md-12 col-sm-12 p-l-5 p-r-10">
                  <div className="card" style={{ cursor: "pointer" }}>
                    <div className="body">
                      <h6 className="my-0">Last 30 days Feedbacks</h6>
                      <div className="mt-3">
                        <small>Total feedbacks in 30 days </small>
                        <h6>{chartData?.totalCount}</h6>
                      </div>

                      <div>
                        <div
                          className="col-lg-12 col-md-12 col-sm-12"
                          style={{ height: "274px" }}
                        >
                          <ReactApexChart
                            options={options}
                            series={series}
                            type="area"
                            height="300px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12 p-l-5 p-r-10">
                  <div className="card">
                    <div className="body">
                      <h6 className="mb-3">Question wise feedback count</h6>
                      <div className="input-group mb-2">
                        <div
                          className="input-group  w-100 justify-content-end align-items-center"
                          data-provide="datepicker"
                        >
                          <DatePicker
                            className="input-sm form-control"
                            selected={startDate}
                            maxDate={endDate}
                            onChange={(date) => {
                              setStartDate(date);
                            }}
                          />
                          <label className="my-0 py-0 mx-3">to </label>
                          <DatePicker
                            className="input-sm form-control"
                            selected={endDate}
                            minDate={startDate}
                            onChange={(date) => {
                              // const dateFrom =
                              //   moment(date).format("YYYY-MM-DD");
                              setEndDate(date);
                            }}
                          />
                        </div>
                      </div>

                      <MDBDataTable
                        noBottomColumns
                        className="table table-hover js-basic-example dataTable table-custom spacing5 action-col-align categories-table stop-overflow-x stop-table-col-overflow heading-lg"
                        // displayEntries={false}
                        displayEntries={false} // Show entries dropdown
                        searching={false} // Disable search
                        paging={true} // Enable pagination
                        entries={5} // Default rows per page
                        entriesOptions={[5, 10, 15, 20]} // Allow user selection
                        data={tableData}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* </div> */}
            </>
          )}
        </div>
      </>
    </>
  );
};

export default FeedbackDashboard;
